/**
 * Main page implementation.
 *
 * @author Dmytro Fedotov <d.fedotov@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id            = 'pageUsb',
    Page          = require('stb-component-page'),
    app           = require('mag-app'),
    page          = new Page({$node: document.getElementById(id)}),
    PanelSet      = require('mag-component-panel-set'),
    PanelExtended = require('mag-component-panel'),
    LayoutList    = require('mag-component-layout-list'),
    ModalMessage  = require('mag-component-modal'),
    RadioList     = require('mag-component-radio-list'),
    dom           = require('spa-dom'),
    keys          = require('stb-keys'),
    Scroll        = require('stb-component-scrollbar'),
    Flicker       = require('spa-component-flicker'),
    Button        = require('stb-component-button'),
    $channelsCountWrapper, $channelsCount;


$channelsCountWrapper = dom.tag(
    'div',
    {className: 'amountContainer'},
    $channelsCount = dom.tag('div', {className: 'amount'}, '0')
);


page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();


/**
 * Convert bytes to human readable text value (GB/MB/KB/B)
 * @param {number} size file size in bytes
 * @return {string} size localised size
 */
page.convert = function ( size ) {
    if ( !size || size < 0 ) { return 'n/a'; }

    if ( size > (1024 * 1024 * 1024) ) {
        return (Math.floor(size / 1024 / 1024 / 1024 * 100) / 100) + ' ' + gettext('GB');
    }
    if ( size > (1024 * 1024) ) {
        return (Math.floor(size / 1024 / 1024 * 100) / 100) + ' ' + gettext('MB');
    }
    if ( size > (1024) ) {
        return (Math.floor(size / 1024 * 100) / 100) + ' ' + gettext('KB');
    }

    return size + ' ' + gettext('B');
};


// middle panel (list)
page.middlePanel = new PanelExtended({
    title: [{value: gettext('Path to image'), className: 'name'}, $channelsCountWrapper],
    main: true,
    children: [],
    className: 'middlePanel'
});


page.middlePanel.modalUsbSelect = new ModalMessage({
    visible: false,
    title: gettext('Select usb'),
    events: {
        show: function () {
            var data       = [],
                focusIndex = 0,
                index;

            for ( index = 0; index < app.storages.length; index++ ) {
                data.push({
                    state: false,
                    title: app.storages[index].label + ' ' + page.convert(app.storages[index].size),
                    value: app.storages[index]
                });
                if ( page.storage === app.storages[index] ) {
                    data[index].state = true;
                    focusIndex = index;
                }
            }
            this.children[0].init({data: data, size: data.length, focusIndex: focusIndex});
            this.focus();
        },
        hide: function () {
            page.panelSet.focus();
        }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            size: 3,
            data: [],
            propagate: true,
            events: {
                'click:item': function ( event ) {
                    page.storage = event.$item.data.value;
                    page.middlePanel.modalUsbSelect.hide();
                    page.middlePanel.reset();
                }
            }
        })
    ]
});
page.add(page.middlePanel.modalUsbSelect);


page.middlePanel.scroll = new Scroll({});


page.middlePanel.add(page.middlePanel.list = new LayoutList({
    cycle: true,
    focusIndex: 0,
    size: 6,
    className: 'padded',
    scroll: page.middlePanel.scroll,
    events: {
        overflow: function () {
            page.middlePanel.list.$focusItem.classList.remove('focus');
            page.middlePanel.scroll.hide();
            page.middlePanel.button.focus();
        },
        keydown: function ( event ) {
            LayoutList.prototype.defaultEvents.keydown.call(this, event);
        }
    },
    data: []
}), page.middlePanel.scroll);


page.middlePanel.reset = function () {
    var usbLabel = page.storage ? page.storage.label + ' ' + page.convert(page.storage.size) : gettext('Connect device'),
        data     = [
            {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('Device:')},
                    {className: 'item text', value: usbLabel}
                ],
                className: 'theme-item-more',
                click: function () {
                    if ( page.storage ) {
                        page.panelSet.blur();
                        page.middlePanel.modalUsbSelect.show();
                    }
                }
            }, {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('Path:')},
                    page.input = dom.tag(
                        'div',
                        {className: 'item text'},
                        page.input ? page.input.innerText : (app.updater.defaultPathToImageOnUsb || '')
                    )
                ],
                className: 'theme-item-more',
                click: function () {
                    window.core.intent({
                        action: 'keyboard',
                        data: {
                            type: 'text',
                            mode: 'qwerty',
                            title: gettext('ENTER PATH'),
                            description: gettext('UPDATE MANAGER'),
                            value: page.input.innerText
                        },
                        events: {
                            done: function ( event ) {
                                page.input.innerText = event.value;
                            }
                        }
                    }, function ( error ) {
                        if ( error ) { console.log(error); }
                    });
                }
            }
        ],
        list     = page.middlePanel.list;

    $channelsCount.innerText = data.length;
    list.init({data: data, focusIndex: list.$focusItem && list.$focusItem.index ? list.$focusItem.index : 0});
};


page.middlePanel.add(page.middlePanel.button = new Button({
    value: gettext('CONTINUE'),
    className: 'bottom theme-footer',
    $node: page.middlePanel.$node.appendChild(document.createElement('div')),
    events: {
        click: function () {
            console.log('check image by url: ' + (page.storage || '').mountPath + '/' + page.input.innerText);
            window.core.plugins.fs.isFileExist((page.storage || '').mountPath + '/' + page.input.innerText, function ( error, exist ) {
                if ( exist && !error ) {
                    app.updater.check({uri: page.storage.mountPath + '/' + page.input.innerText}, function ( error, data ) {
                        console.log('check error? ' + error);
                        if ( error ) {
                            window.core.notify({
                                title: gettext('Can\'t check this image') + ': ' + error.message,
                                icon: 'alert',
                                type: 'warning'
                            });
                        } else {
                            app.route(app.pages.info, [data]);
                        }
                    });
                } else {
                    window.core.notify({
                        title: gettext('Can\'t find image by this path'),
                        icon: 'alert',
                        type: 'warning'
                    });
                }
            });
        },
        keydown: function ( event ) {
            if ( event.code === keys.up ) {
                page.middlePanel.list.focus();
                page.middlePanel.scroll.show();
                // restore taken focus class
                page.middlePanel.list.$focusItem.classList.add('focus');
                page.middlePanel.list.focusIndex(page.middlePanel.list.data.length - 1);
            } else if ( event.code === keys.down ) {
                page.middlePanel.list.focus();
                page.middlePanel.scroll.show();
                // restore taken focus class
                page.middlePanel.list.$focusItem.classList.add('focus');
                page.middlePanel.list.focusIndex(0);
            } else if ( event.code === keys.ok ) {
                if ( page.middlePanel.button.events['click'] ) {
                    page.middlePanel.button.emit('click', {event: event});
                }
            }
        }
    }
}));


// panel set: main
page.panelSet = new PanelSet({
    visible: true,
    $node: document.getElementById('panelSetUsb'),
    focusIndex: 0,
    panels: [page.middlePanel]
});
page.add(page.panelSet);


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            app.route(app.pages.main);
            break;
    }
});


page.addListener('show', function () {
    page.storage = page.storage || app.storages[0];
    page.panelSet.show();
    page.panelSet.focus();
    page.middlePanel.reset();
    // give focus to button
    page.middlePanel.list.$focusItem.classList.remove('focus');
    page.middlePanel.scroll.hide();
    page.middlePanel.button.focus();
});


// public
module.exports = page;
